export const SAMPLE_PROMPTS= [
  {
    title: 'Create Variants with Sequential SKUs and Details',
    prompt: "Create 5 variants, its 1st SKU is \"232DSS0D1\" and other SKUs are in sequential order of 1st SKU. Also add details mentioned below for all variants:\n1- Item type is \"ITHDSDS\"\n2- Material number is \"MNHKDS132\"\n3- Enable Purchase and Rent flag\n4- Provide \"Weighting\" in attribute=\"999\" for all variants\n5- Weight is 2 kg",
    description: 'Generate 5 variants with auto-incrementing SKUs, item type, material number, purchase/rent flags, and attributes'
  },
  {
    title: 'Create Variants with Specific SKUs',
    prompt: 'Create 2 variants having SKUs are "T2310D2" and "PDF23J"',
    description: 'Generate 2 variants with predefined SKU values'
  },
  {
    title: 'Delete Specific Variants by SKU',
    prompt: 'Delete variants having SKU: [enter your desired SKU values]',
    description: 'Remove specific variants by providing their SKU values'
  },
  {
    title: 'Delete Variants by Weight Condition',
    prompt: 'Delete variants having weight is 2',
    description: 'Remove all variants that match a specific weight value'
  },
  {
    title: 'Bulk Update Multiple Fields',
    prompt: 'Update Weight=2 and Item Type="ITHDSDS" for all variants',
    description: 'Update weight and item type for all product variants at once'
  },
  {
    title: 'Update Multiple Fields for Specific Variants',
    prompt: 'Set Weight=2.4, Item Type="ITTest2" and Material number="MNHKDS921"  for variants having SKUs: [enter your desired SKU values]',
    description: 'Modify weight, item type, and material number for selected SKUs'
  },
];